<!--登录-->
<template>
  <div class="w">
    <div class="header-box">
      <div class="header-nav">
        <div @click="toHome()" class="header-left">文档库</div>
        <div class="">
          <el-button type="primary">修改密码</el-button>

          <el-button type="danger" @click="exit">退出登录</el-button>
        </div>
      </div>
    </div>
    <div class="login-container1">
      <div class="content-container">
        <el-form
          ref="loginForm"
          :model="loginForm"
          :rules="loginRules"
          class="login-form"
          label-position="right"
          label-width="80px"
        >
          <el-form-item
            prop="phone"
            label="账号"
            :hide-required-asterisk="false"
            style="font-size: 20px"
          >
            <el-input
              ref="username"
              v-model="loginForm.phone"
              placeholder="请输入手机号"
              name="username"
              @input="input"
              :maxlengt="11"
              max="11"
            />
          </el-form-item>
          <el-form-item prop="code" label="验证码">
            <div class="verification-box">
              <el-input
                :key="passwordType"
                v-model="loginForm.code"
                :type="passwordType"
                placeholder="请输入验证码"
                tabindex="2"
                auto-complete="on"
                @keyup.enter.native="handleLogin"
                style="width: 470px"
              />

              <!--发送验证码按钮-->
              <el-button type="primary" @click="sendCode" :disabled="draw">
                {{ content }}
              </el-button>
            </div>

            <!-- <span class="show-pwd" @click="showPwd" style="width: 20px">
            <svg-icon :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'" />
          </span> -->
          </el-form-item>
          <el-form-item prop="password" label="新密码">
            <div class="verification-box">
              <el-input
                :key="passwordType"
                ref="password"
                v-model="loginForm.password"
                type="password"
                placeholder="请输入新密码"
                name="password"
                tabindex="2"
                auto-complete="on"
                @keyup.enter.native="handleLogin"
              />
            </div>
          </el-form-item>

          <el-form>
            <div class="login-box">
              <el-button :loading="loading" type="primary" @click="handleLogin">
                确定修改密码
              </el-button>
            </div>
          </el-form>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { validUsername } from "@/utils/validate";
import { getCode, changePassword } from "@/api/user";
export default {
  data() {
    const validateUsername = (rule, value, callback) => {
      if (!validUsername(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };
    const validateCode = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error("验证码不能少于6位"));
      } else {
        callback();
      }
      return;
    };

    const validatePassword = (rule, value, callback) => {
      if (value.match(/^\s*$/)) {
        callback(new Error("请输入新密码"));
      } else {
        callback();
      }
    };
    return {
      // 登录方式 1 == 必须验证码登录 0 == 必须手机号 2 验证码/手机号
      loginWay: "手机号",
      content: "发送验证码",
      totalTime: 30, //倒计时
      canClick: true, //添加canClick
      draw: false,

      loginForm: {
        phone: "",
        password: "",
        code: "",
      },
      loginRules: {
        phone: [
          { required: false, trigger: "blur", validator: validateUsername },
        ],
        password: [
          { required: false, trigger: "blur", validator: validatePassword },
        ],
        code: [{ required: false, trigger: "blur", validator: validateCode }],
      },
      loading: false,
      passwordType: "text",
      redirect: undefined,
      loginWayType: 0,
    };
  },
  methods: {
    toHome() {
      this.$router.push({
        path: "/",
      });
    },
    exit() {
      this.$confirm("是否是真的退出, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "退出成功!",
          });
          localStorage.setItem("token", "");
          this.$router.push({
            path: "/login",
          });
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // });
        });
    },
    // 登录
    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true;

          changePassword(this.loginForm)
            .then((resp) => {
              if (resp.code == 200 && resp.msg == "OK") {
                this.$message({
                  message: resp.msg,
                  type: "warning",
                  duration: 5 * 1000,
                });
                this.loading = false;
                // this.$setCookie("token", resp.data, 30);
                localStorage.setItem("token", resp.data);
                // this.$store.dispatch('aiclass/user/saveOrgans', resp.data.organs)
                this.$router.push("/");
                return;
              } else {
                this.loading = false;
                this.$message({
                  message: resp.msg,
                  type: "warning",
                  duration: 5 * 1000,
                });
              }
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    },
    showPwd() {
      if (this.passwordType === "password") {
        this.passwordType = "";
      } else {
        this.passwordType = "password";
      }
      this.$nextTick(() => {
        this.$refs.password.focus();
      });
    },
    input() {
      this.loginForm.phone = this.loginForm.phone.replace(/[^0-9]/g, "");
    },
    //用户登录
    getData() {
      // userlogin().then((res) => {
      //   this.userlogin = res
      // })
    },
    //获取验证码
    getCode() {
      // this.loading = true;
      getCode({ phone: this.loginForm.phone }).then((res) => {
        if (res.code == 200) {
          // this.loginForm.password = res.message;
        } else {
          this.$message({
            message: res.msg,
            type: "warning",
            duration: 5 * 1000,
          });
        }
        // this.studentslist = res
        // 测试用
        // console.log(this.studentslist.str.type)
      });
    },
    //获取验证码
    sendCode(canClick) {
      if (!canClick) {
        return;
      } //节流
      // if(!this.loading){
      //   return
      // }
      this.getCode();
      this.canClick = false;
      this.draw = true;
      this.content = this.totalTime + "s后重新发送";
      let clock = window.setInterval(() => {
        this.totalTime--;
        this.content = this.totalTime + "s后重新发送";
        if (this.totalTime < 0) {
          //当倒计时小于0时清除定时器
          window.clearInterval(clock); //关闭
          this.content = "重新发送验证码";
          this.totalTime = 30;
          this.canClick = true; //这里重新开启
          this.draw = false;
        }
      }, 1000);
    },
  },
};
</script>

<style lang="scss">
/* 修复input 背景不协调 和光标变色 */
/* Detail see https://github.com/PanJiaChen/vue-element-admin/pull/927 */

$bg: #fff;
$cursor: #333; //输入颜色
$placeholder: #747474; //占位文本

/* reset element-ui css */
.login-container {
  min-width: 800px;
  min-height: 600px;
  display: flex;
}
</style>


<style lang="scss" >
.login-container1 {
  .el-form-item__label {
    font-size: 17px;
  }
  .el-button{
    font-size: 17px;

  }
}
</style>

<style lang="scss" scoped>
$bg: #021859;
$dark_gray: #747474;
$btn: #225493;
$btn_hover: #3d6494;
$btn_click: #1d4a80;
.header-nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 20px;
  .header-left {
    cursor: pointer;
    font-size: 25px;
    color: #19aff1;
  }
}
.login-container1 {
  width: 100%;
  height: 100%;
  /*background-color: $bg;*/
  background-size: 100% 100%;
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  .login-header-cut {
    display: flex;
    justify-content: flex-end;
    font-size: 17px;
    color: #09aaff;
    cursor: pointer;
  }
  .login-box {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .verification-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .content-container {
    width: 850px;
    height: 500px;
    max-width: 100%;
    max-height: 100%;
    display: flex;
  }

  .form-title {
    color: white;
    font-size: 36px;
  }
  /*登录表单*/
  .login-form {
    position: relative;
    width: 100%;
    padding: 60px;
    overflow: hidden;
    background-color: white;
  }

  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;

    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }

  .svg-container {
    padding: 6px 5px 6px 15px;
    color: $dark_gray;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
  }

  .title-container {
    position: relative;
    margin-bottom: 55px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .title {
      font-size: 40px;
      margin: 0px auto 10px auto;
      font-weight: 400;
      font-family: Arial;
    }
    .sub-title {
      font-size: 22px;
      color: #333;
    }
  }

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }
}
.login-container .el-form-item {
  border: none;
}

.login-container .el-input {
  width: 100%;
}
</style>


<style  scoped>
/* .content-container  /deep/  .el-input__inner{
    border-color: #c0c4cc;
} */
</style>